export default __webpack_public_path__ + "static/media/cp_geo_bm.458f98ec.svg";